<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'daterang', label: '사업기간' },
      ]"
    />

    <!-- 점검개요 -->
    <div class="mb-4">
      <div>
        <h5><i class="dot"></i>회의 정보</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>회의장소</div>
        <div>
          <ml-input v-model="form.회의장소" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>토의 및 의결사항</div>
        <div>
          <ml-textarea v-model="form.토의및의결사항" rows="30" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>기타의견</div>
        <div>
          <ml-textarea v-model="form.기타의견" rows="5" placeholder="기타의견(종사자 의견 청취 사항 등" />
        </div>
      </div>
    </div>

    <!--    도급인, 수급인 정보-->
    <div class="flex mt-4 gap-4">
      <table-custom
        class="flex-1"
        :board="board"
        :is-print="isPrint"
        title="도급인"
        :tableData="[
          { id: '소속명', title: '소속명', type: 'text', placeholder: '내용' },
          { id: '이름', title: '이름', type: 'text', placeholder: '내용' },
          { id: '서명', title: '서명', type: 'sign', placeholder: '내용' },
        ]"
        v-model="form.도급인"
        thema="label"
      />

      <table-custom
        class="flex-1"
        :board="board"
        :is-print="isPrint"
        title="수급인"
        :tableData="[
          { id: '소속명', title: '소속명', type: 'text', placeholder: '내용' },
          { id: '이름', title: '이름', type: 'text', placeholder: '내용' },
          { id: '서명', title: '서명', type: 'sign', placeholder: '내용' },
        ]"
        v-model="form.수급인"
        thema="label"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="회의사진" :show-footer-input="false" />

    <!--    확인자 -->
    <div class="mt-8 mb-4">
      <div>
        <h5><i class="dot"></i>확인자</h5>
      </div>
    </div>
    <name-with-signature-row label-name="담당" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
    <name-with-signature-row label-name="팀장" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
    <name-with-signature-row label-name="부서장" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableCustom,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        회의장소: "",
        토의및의결사항:
          "1) 전월 회의 개선 요청사항 및 개선 조치 결과 확인\n" +
          "-\n" +
          "2) 작업의 시작 및 종료 시간에 관한 사항\n" +
          "- 작업 시작시간 09:00, 작업 종료시간 18:00\n" +
          "3) 작업 시 안전보건확보 방안(비상연락망, 재해발생대비 비상대응조직 구축)\n" +
          "- 시와 수급업체 간 비상연락망 및 비상대응조직 구축\n" +
          "- 비상 상황 발생시 대응 조치 절차에 대한 교육 및 게시\n" +
          "4) 근로자 보호구 착용 등 안전 및 보건에 관한 운영\n" +
          "-\n" +
          "5) 수급인이 행하는 근로자의 안전보건교육에 대한 지도와 지원\n" +
          "-\n" +
          "6) 위험성평가 실시에 관한 사항\n" +
          "-\n" +
          "7) 기타 산업재해 예방을 위해 필요한 사항\n" +
          "-\n" +
          "8) 향후 안전보건협의체 개최일\n" +
          "- ",
        기타의견: "",

        도급인: [],
        수급인: [],

        sign1: {
          team: "",
          name: "",
          sign: "",
        },
        sign2: {
          team: "",
          name: "",
          sign: "",
        },
        sign3: {
          team: "",
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
